<h1 mat-dialog-title>{{ data.title || 'Action' }}</h1>

<div mat-dialog-content style="overflow: visible; min-width: 300px; padding-top: 8px;">
  <cs-form-generator-nxt
    #formRef
    [data]="data.formData"
    [disableFormErrorChecking]="false"
  ></cs-form-generator-nxt>
</div>

<div mat-dialog-actions style="justify-content: flex-end; gap: 8px;">
  <button class="btn btn-md" (click)="onCancel()">Cancel</button>
  <button
    class="btn btn--primary btn-md"
    [disabled]="!isValid"
    (click)="onConfirm()"
  >{{ data.confirmLabel || 'OK' }}</button>
</div>
